import Player from '@vimeo/player';

export const initialiseVideoPlaceholder = () => {
    const vimeoPlaceholder = (wrapper) => {
        var iframe = wrapper.querySelector('iframe');

        var player = new Player(iframe);

        player.on('loaded', function() {
            wrapper.classList.add('loaded');
        });
    }

    const youtubePlaceholder = (wrapper) => {
        var iframe = wrapper.querySelector('iframe');

        // YouTube iframe API uses a different approach
        // First, ensure the YouTube API is loaded
        if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
            return;
        }

        // Create a YouTube player instance
        var player = new YT.Player(iframe, {
            events: {
                'onReady': function(event) {
                    wrapper.classList.add('playing');
                }
            }
        });
    }

    document.querySelectorAll('.js-video-wrapper').forEach(wrapper => {
        if (wrapper.classList.contains('js-video-type-vimeo')) {
            vimeoPlaceholder(wrapper);
        } else if (wrapper.classList.contains('js-video-type-youtube')) {
            youtubePlaceholder(wrapper);
        }
    });
};
